import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { formatDateTime, formatDate } from '../../../../../utils/formatDates';
import encodeBase64 from '../../../../../utils/encodeBase64';
import { useHistory } from 'react-router-dom';
import Status from '../../../../../components/Status';
import useLanguage from '../../../../../customHooks/useLanguage';
import useTimeZone from '../../../../../customHooks/useTimeZone';
import routes from '../../../../../utils/commonVariables/routes';
import Tooltip from '../../../../../muiComponents/Tooltip';

const BookingTableRow = ({ row }) => {
    const history = useHistory();
    const language = useLanguage();
    const timeZone = useTimeZone();

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => {
                const currentPath = history.location.pathname;
                history.push(`${currentPath}/${encodeBase64(row.Id)}`);
            }}
        >
            <TableCell>
                <Status text={row.Status} color={row.StatusColor} />
            </TableCell>
            <TableCell>{row.BookingCode}</TableCell>
            <TableCell
                onClick={e => {
                    e.stopPropagation();
                    const route = `${routes.propertyDetail(
                        row.IdSupplierHotel
                    )}`;
                    window.open(route, route);
                }}
            >
                <Tooltip titleText='navigate_to_hotel_detail'>
                    <h3 className='font-weight-600 text-secondary-700 width-content link-onhover'>
                        {row.SupplierHotel}
                    </h3>
                </Tooltip>
            </TableCell>
            <TableCell>
                {formatDateTime(row.BookingDate, language, timeZone)}
            </TableCell>
            <TableCell>{formatDate(row.CheckInDate, language)}</TableCell>
            <TableCell>{formatDate(row.CheckOutDate, language)}</TableCell>
        </TableRow>
    );
};

export default BookingTableRow;
